import ProductService from './services';
import ProductTypes from './types';

export const loadProduct = (id: number, ignoreActiveAffiliates: boolean = false) =>
  ProductTypes.product.createAction(() => ProductService.loadProductById(id, ignoreActiveAffiliates));
export const listProducts = (filters?: any, pagination?: any, producer?: any) =>
  ProductTypes.list.createAction(() => ProductService.listMyProductsSales(filters, pagination, producer));
export const listMyProducts = (filters?: any, pagination?: any) =>
  ProductTypes.listMine.createAction(() => ProductService.listMyProducts(filters, pagination));
export const listVariations = (id: number) => ProductTypes.listVariations.createAction(() => ProductService.listMyVariations(id));
export const listCoProducers = (id: number) => ProductTypes.coProducers.createAction(() => ProductService.listCoProducer(id));
export const newProduct = (product: any) => ProductTypes.new.createAction(() => ProductService.newProduct(product));

export const enableMelhorEnvioAuth = (melhorEnvioCode: string) =>
  ProductTypes.enableMelhorEnvioAuth.createAction(() => ProductService.enableMelhorEnvioAuth(melhorEnvioCode));
export const getDeliveryIntegrationActiveList = () =>
  ProductTypes.getDeliveryIntegrationActiveList.createAction(() => ProductService.getDeliveryIntegrationActiveList());
export const editProduct = (id: number, product: any) => ProductTypes.edit.createAction(() => ProductService.editProduct(id, product));
export const listCategories = () => ProductTypes.categories.createAction(() => ProductService.listCategories());
export const listDeliveryMethods = (id: number) => ProductTypes.deliveryMethods.createAction(() => ProductService.listDeliveryMethod(id));
export const listProductBadges = (id: number) => ProductTypes.productBadges.createAction(() => ProductService.listProductBadgesMethod(id));
export const loadFile = (id: number) => ProductTypes.file.createAction(() => ProductService.loadFileById(id));
export const listProductInvoice = (id: number) => ProductTypes.productInvoice.createAction(() => ProductService.listProductInvoiceMethod(id));
export const getAffiliatesProductStatusSummary = (id: number) =>
  ProductTypes.affiliatesProductStatusSummary.createAction(() => ProductService.getAffiliatesProductStatusSummaryMethod(id));
export const productStatus = (id: number, status: number) =>
  ProductTypes.productStatus.createAction(() => ProductService.productStatusMethod(id, status));
export const productInviteAffiliate = (id: number, email: string) =>
  ProductTypes.inviteAffiliations.createAction(() => ProductService.productInviteAffiliateMethod(id, email));
export const productDelivery = (id: number, email: string) =>
  ProductTypes.productDelivery.createAction(() => ProductService.productDelivery(id, email));
export const addNewCoproducer = (id: number, product: any) =>
  ProductTypes.newCoproducer.createAction(() => ProductService.addNewCoproducer(id, product));
export const cloneProductById = (id: number, parentId?: number) =>
  ProductTypes.cloneProductById.createAction(() => ProductService.cloneProductById(id, parentId));
export const listProductsChildren = (id: number, status?: string) =>
  ProductTypes.listProductsChildren.createAction(() => ProductService.listProductsChildrenByID(id, status));
export const listProductCampaigns = (
  idProduct: number,
  pagination?: any,
  filters?: any,
  onlyAffiliates?: boolean,
  producer?: boolean,
  myLinks?: boolean
) =>
  ProductTypes.productCampaigns.createAction(() =>
    ProductService.listProductCampaigns(idProduct, pagination, filters, onlyAffiliates, producer, myLinks)
  );
export const editProductCampaign = (idProduct: number, idCampaign?: number, campaign?: any) =>
  ProductTypes.editProductCampaign.createAction(() => ProductService.editProductCampaign(idProduct, idCampaign, campaign));
export const createProductCampaign = (idProduct: number, campaign: any) =>
  ProductTypes.createProductCampaign.createAction(() => ProductService.createProductCampaign(idProduct, campaign));
export const listPostback = (idProduct: any, destiny: any, type: any) =>
  ProductTypes.listPostback.createAction(() => ProductService.listPostback(idProduct, destiny, type));
export const updatePostback = (idProduct: any, script: any, destiny: any, type: any) =>
  ProductTypes.updatePostback.createAction(() => ProductService.updatePostback(idProduct, script, destiny, type));
export const createProductCampaignTracker = (tracker: any, idProduct: any) =>
  ProductTypes.createProductCampaignTracker.createAction(() => ProductService.createProductCampaignTracker(tracker, idProduct));
export const loadProductCampaignTracker = (idProduct: any, type?: any) =>
  ProductTypes.loadProductCampaignTracker.createAction(() => ProductService.loadProductCampaignTracker(idProduct, type));
export const verifyDomain = (productId: number) => ProductTypes.verifyDomain.createAction(() => ProductService.verifyDomain(productId));
export const listCoupons = (idProduct: any, pagination: any, status: string) =>
  ProductTypes.listCoupons.createAction(() => ProductService.listCoupons(idProduct, pagination, status));
export const excludeCoupon = (idProduct: any, couponId: any) =>
  ProductTypes.excludeCoupon.createAction(() => ProductService.excludeCoupon(idProduct, couponId));
export const createCoupons = (idProduct: any, coupon: any) =>
  ProductTypes.createCoupons.createAction(() => ProductService.createCoupons(idProduct, coupon));
export const listCoProductions = (pagination: any, title?: string) =>
  ProductTypes.listCoProductions.createAction(() => ProductService.listCoProductions(pagination, title));
export const listAffiliations = (pagination: any, title?: string) =>
  ProductTypes.listAffiliations.createAction(() => ProductService.listAffiliations(pagination, title));
export const inviteAffiliations = (product: any, email: string) =>
  ProductTypes.inviteAffiliations.createAction(() => ProductService.inviteAffiliationsbyEmail(product, email));
export const cancelAffilation = (id: number) => ProductTypes.cancelAffilation.createAction(() => ProductService.cancelAffilation(id));
export const listRecoveryMessages = (idProduct: any) =>
  ProductTypes.listRecoveryMessages.createAction(() => ProductService.listRecoveryMessages(idProduct));
export const updateRecoveryMessages = (idProduct: any, idMessage: any, message: any) =>
  ProductTypes.updateRecoveryMessages.createAction(() => ProductService.updateRecoveryMessages(idProduct, idMessage, message));
export const createRecoveryMessages = (idProduct: any, message: any) =>
  ProductTypes.createRecoveryMessages.createAction(() => ProductService.createRecoveryMessages(idProduct, message));
export const deleteProductCampaignTracker = (id: any, type: string) =>
  ProductTypes.deleteProductCampaignTracker.createAction(() => ProductService.deleteProductCampaignTracker(id, type));
export const listCouponsBatch = (idProduct: any, pagination: any, status: string) =>
  ProductTypes.listCouponsBatch.createAction(() => ProductService.listCouponsBatch(idProduct, pagination, status));
export const exportCouponsBatch = (idProduct: any, BatchHash: string) =>
  ProductTypes.exportCouponsBatch.createAction(() => ProductService.exportCouponsBatch(idProduct, BatchHash));
export const createCouponsBatch = (file: File | Blob, couponValues: any, productId: number) =>
  ProductTypes.createCouponBatch.createAction(() => ProductService.createCouponBatch(file, couponValues, productId));
export const inactivateBatch = (idProduct: any, BatchHash: string) =>
  ProductTypes.inactivateBatch.createAction(() => ProductService.inactivateBatch(idProduct, BatchHash));
export const listProductsCampaignFilter = () =>
  ProductTypes.listProductsCampaignFilter.createAction(() => ProductService.listProductsCampaignFilter());

export function clearProduct(): any {
  return (dispatch: any) => {
    dispatch({ type: '@@service/PRODUCT/LIST_RESET' });
  };
}
